import { TicketRedemptionCardType } from '@vista-digital/ocapi-types/v1';
import { getOrderTicketRedemptionCards } from './get-order-ticket-redemption-cards';
export const getOrderTicketRedemptionCardsForSubscription = (subscriptionId) => {
    return getOrderTicketRedemptionCards().filter(card => {
        if (card.type !== TicketRedemptionCardType.MemberSubscriptionCard)
            return false;
        return card.subscriptionId === subscriptionId;
    });
};
